/* eslint-disable */
/**
 * #290 Incapsula doesn't cache the 'Set-Cookie' header
 * So we have to set the cookie in JS-land :rolleyes:
 */

import Cookies from 'js-cookie';

const setLanguageCookie = () => {
    if (window.drupalSettings && window.drupalSettings.http) {
        if (window.drupalSettings.http['Set-Cookie'] !== undefined) {
            window.drupalSettings.http['Set-Cookie'].map(({ name, value }) => {
                Cookies.set(name, value, { expires: 365 });
            });
        }
    }
};

export { setLanguageCookie };
